var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSicon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4875 85.675H3.7375C2.44375 85.675 1.4375 84.6687 1.4375 83.375V62.675C1.4375 61.3812 2.44375 60.375 3.7375 60.375H9.4875C10.7812 60.375 11.7875 61.3812 11.7875 62.675V83.375C11.9312 84.6687 10.7812 85.675 9.4875 85.675Z",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0996 61.6687C19.2621 58.5062 21.4184 53.9062 23.2871 48.4437C26.1621 48.4437 28.6059 50.8875 28.6059 53.7625V54.625L27.1684 64.4L35.0746 64.1125C38.8121 63.9687 41.5434 67.275 40.9684 71.0125L39.2434 79.925C38.6684 82.6562 36.3684 84.6687 33.6371 84.6687H24.0059C22.2809 84.6687 20.5559 84.525 18.9746 84.0937L16.5309 83.5187",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7564 83.2313L73.3127 83.9501C71.5877 84.3813 70.0064 84.525 68.2814 84.525H58.6502C55.9189 84.525 53.4752 82.5126 52.9002 79.7813L51.1752 70.8688C50.4564 67.275 53.3314 63.9688 57.0689 63.9688L64.9752 64.2563L63.5377 54.4813C63.5377 54.1938 63.5377 53.9063 63.5377 53.6188C63.5377 50.7438 65.8377 48.3 68.8564 48.3C70.5814 53.7625 72.8814 58.3625 76.0439 61.525",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5134 85.675H88.2634C89.5571 85.675 90.5634 84.6687 90.5634 83.375V62.675C90.5634 61.3812 89.5571 60.375 88.2634 60.375H82.5134C81.2196 60.375 80.2134 61.3812 80.2134 62.675V83.375C80.0696 84.6687 81.2196 85.675 82.5134 85.675Z",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0008 50.4563C55.4483 50.4563 63.107 42.7975 63.107 33.35C63.107 23.9025 55.4483 16.2438 46.0008 16.2438C36.5533 16.2438 28.8945 23.9025 28.8945 33.35C28.8945 42.7975 36.5533 50.4563 46.0008 50.4563Z",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.407 41.4C41.6883 41.4 40.9695 41.1125 40.3945 40.5375L36.9445 37.0875C35.7945 35.9375 35.7945 34.2125 36.9445 33.0625C38.0945 31.9125 39.8195 31.9125 40.9695 33.0625L42.407 34.5L50.8883 26.0188C52.0383 24.8687 53.7633 24.8687 54.9133 26.0188C56.0633 27.1688 56.0633 28.8937 54.9133 30.0437L44.4195 40.5375C43.9883 41.1125 43.1258 41.4 42.407 41.4Z",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10.2062V6.32495",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1445 33.35H73.0258",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9746 33.35H22.8559",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3867 16.9625L65.118 14.2312",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8809 14.2312L29.6121 16.9625",
    stroke: "#002661",
    strokeWidth: 2.1992,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSicon7);
export default __webpack_public_path__ + "static/media/sicon7.354241e6038ac68a2d5695a8e0c4d324.svg";
export { ForwardRef as ReactComponent };